module.exports = __webpack_public_path__ + "img/klcx_08.55c5ebb8.jpg";